import React from 'react';
import './Features.css';

const Features = () => {
  const features = [
    {
      icon: '📊',
      title: 'Real-time Cost Analytics',
      description: 'Monitor your AWS spending in real-time with detailed breakdowns by service, region, and team. Get instant alerts when costs exceed thresholds.'
    },
    {
      icon: '🤖',
      title: 'Automated FinOps Plugins',
      description: 'Deploy intelligent automation plugins directly to your AWS account. Automatically optimize resources, schedule shutdowns, and implement cost-saving policies.'
    },
    {
      icon: '🔍',
      title: 'Cost Anomaly Detection',
      description: 'AI-powered anomaly detection identifies unusual spending patterns and potential cost leaks before they impact your budget.'
    },
    {
      icon: '📈',
      title: 'Forecasting & Budgeting',
      description: 'Accurate cost forecasting based on historical data and usage trends. Set budgets and get proactive recommendations to stay on track.'
    },
    {
      icon: '🏷️',
      title: 'Resource Tagging & Allocation',
      description: 'Comprehensive tagging strategies and cost allocation across departments, projects, and environments for complete visibility.'
    },
    {
      icon: '⚡',
      title: 'Right-sizing Recommendations',
      description: 'Get intelligent recommendations for instance types, storage classes, and resource configurations to optimize performance and costs.'
    }
  ];

  return (
    <section id="features" className="features">
      <div className="container">
        <div className="section-header text-center">
          <h2>Powerful FinOps Features</h2>
          <p>Everything you need to optimize your AWS costs and implement financial best practices</p>
        </div>
        
        <div className="features-grid grid grid-3">
          {features.map((feature, index) => (
            <div key={index} className="feature-card card">
              <div className="feature-icon">{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;